import * as Sentry from '@sentry/react';

/**
 * Start a Sentry session replay on demand, gated by a client-side sample rate.
 *
 * Replay is otherwise off by default (``replaysSessionSampleRate`` is 0 in
 * ``initSentry``), so this lets specific interactions opt into recording a
 * fraction of sessions. A no-op if replay is unavailable (e.g. development,
 * where Sentry is disabled) or a replay is already in progress.
 *
 * @param sampleRate fraction of calls that should start a replay (0..1)
 */
export function startSentryReplaySampled(): void {
    const sampleRate = Number(import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE ?? 0);
    if (Math.random() >= sampleRate) {
        return;
    }
    const replay = Sentry.getReplay();
    if (replay && !replay.getReplayId()) {
        replay.start();
    }
}
